import type React from "react";

import usePayment, { ICard, ICreditCard, PaymentMethods } from "hooks/usePayment";
import CardDebitInfo from "../CardDebitInfo";
import CardIdentification from "../CardIdentification";
import CardPaymentInfo from "../CardPaymentInfo";
import { useCheckout } from "../../hooks/useCheckout";
import { useInstallments } from "../../hooks/useInstallment";
import SummaryValue from "./components/SummaryValue";
import * as Summary from "./styles";
import { PaymentWrapper, Title, TitleRow, WrapperBox } from "components/PaymentForm/styles";
import { CircleNumber } from "../PaymentCheckout/styles";
import { usePaymentNavigation } from "components/PaymentForm/hooks/usePaymentNavigation";
import { EnumStages } from "views/Partner/types";
import { isCard } from "components/PaymentForm/utils";

interface PaymentSummaryProps {
  onBack: () => void;
  nextStage: () => void;
  setTokenRecaptcha: (token: string | null) => void;
  tokenRecaptcha: string | null;
  isLoadingInstallments: boolean;
  route: string;
  stage: EnumStages;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({ onBack, nextStage, setTokenRecaptcha, route, stage, tokenRecaptcha, isLoadingInstallments }) => {
  const { dataPaymentBillet, client, paymentMethods } = usePayment();
  const { createCheckout, isLoading } = useCheckout({ tokenRecaptcha: tokenRecaptcha })
  const { handleInstallmentInfo } = useInstallments()
  usePaymentNavigation({ route, stage });

  async function handleGoToPayment() {
    await createCheckout({ onSuccess: () => nextStage() })
  }

  return (
    <PaymentWrapper enable={true}>
      <WrapperBox>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <TitleRow>
            <CircleNumber>
              <span style={{ height: "26px" }}>4</span>
            </CircleNumber>
            <Title>Resumo</Title>
          </TitleRow>
          <h4 style={{ marginBottom: "30px", fontSize: "20px", color: "#312F30", fontWeight: "300" }}>Veja como estão as coisas por aqui, antes de seguir para o pagamento.</h4>
        </div>
        <Summary.Container>
          <Summary.SummarySection>
            <Summary.LeftColumn>
              <Summary.SectionTitle>Identificação</Summary.SectionTitle>
              <CardIdentification name={client.name} document={client.document} />
              <Summary.SectionTitle>Débitos</Summary.SectionTitle>
              {dataPaymentBillet?.debits?.filter(debit => !debit?.redirect_to_be_paid).map((debit) => (
                <CardDebitInfo
                  name={debit.description}
                  amount={debit.amount}
                  key={debit.id_debit}
                />
              ))}
              {dataPaymentBillet?.billets.map((debit) => (
                <CardDebitInfo
                  name={debit.recipient.name}
                  amount={debit.amount.total}
                  key={debit.id_bill}
                  isBill
                />
              ))}
              {dataPaymentBillet?.pix.map((debit) => (
                <CardDebitInfo
                  name={debit.key}
                  amount={debit.amount.total}
                  key={debit.id_pix}
                  isPix
                />
              ))}
              <Summary.SectionTitle>Pagamentos</Summary.SectionTitle>
              {paymentMethods?.map((payment: PaymentMethods, index: number) => (
                <CardPaymentInfo
                  key={payment.typeMethod}
                  onEdit={onBack}
                  isLoading={isLoadingInstallments}
                  type={payment.typeMethod}
                  value={handleInstallmentInfo(payment, index)?.original_amount || 0}
                  fee={handleInstallmentInfo(payment, index)?.fee_amount || 0}
                  description={handleInstallmentInfo(payment, index)?.description}
                  cardNumber={isCard(payment) ? payment.number : undefined}
                />
              ))}
            </Summary.LeftColumn>

            <Summary.RightColumn>
              <SummaryValue
                isLoadingInstallments={isLoadingInstallments}
                setTokenRecaptcha={setTokenRecaptcha}
                tokenRecaptcha={tokenRecaptcha}
                handleGoToPayment={handleGoToPayment}
                isLoading={isLoading}
              />
            </Summary.RightColumn>
          </Summary.SummarySection>
        </Summary.Container>
      </WrapperBox>
    </PaymentWrapper>
  );
};

export default PaymentSummary;
